module.exports = __webpack_public_path__ + "static/img/公司7.151e889.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司7.jpg
// module id = dX4u
// module chunks = 1